import React from "react";
import { Link } from "react-router-dom";

import Logo from "components/layout/Logo";
import { BackIcon } from "features/player/icons";

// Grey bar across the player: back link left, logo centred (univ.mekari.com).
export default function PlayerTopBar() {
  return (
    <header className="yc-player-topbar">
      <Link to="/" className="yc-player-back">
        <BackIcon />
        Back to "My classes"
      </Link>
      <Logo className="yc-player-logo" />
    </header>
  );
}
